import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/use-mobile';
import { useCategories } from '@/hooks/categories/useCategories';
interface ParticulierTypeStepProps {
  onComplete: (data: {
    typeEvenement: string;
  }) => void;
}

// Mapping des emojis pour les évènements
const eventEmojis: {
  [key: string]: string;
} = {
  'anniversaire': '🎂',
  'mariage': '💍',
  'wedding': '💍',
  'demande en mariage': '💝',
  'autre': '✨'
};
const getEventEmoji = (title: string): string => {
  const lowerTitle = title.toLowerCase();
  for (const [key, emoji] of Object.entries(eventEmojis)) {
    if (lowerTitle.includes(key)) {
      return emoji;
    }
  }
  return '🎉'; // Emoji par défaut
};
export const ParticulierTypeStep = ({
  onComplete
}: ParticulierTypeStepProps) => {
  const [customType, setCustomType] = useState('');
  const [showCustomInput, setShowCustomInput] = useState(false);
  const isMobile = useIsMobile();

  // Récupérer les évènements particuliers de la base de données
  const {
    categories,
    isLoading
  } = useCategories(false, 'particulier');
  const handleTypeSelect = (eventTitle: string) => {
    onComplete({
      typeEvenement: eventTitle
    });
  };
  const handleCustomTypeSubmit = () => {
    if (customType.trim()) {
      onComplete({
        typeEvenement: customType.trim()
      });
    }
  };
  if (isLoading) {
    return <div className="space-y-3">
        <div className="text-center text-muted-foreground">
          Chargement des types d'évènements...
        </div>
      </div>;
  }
  return <div className="space-y-3">
      <div className={`grid gap-2 ${isMobile ? 'grid-cols-1' : 'grid-cols-1'}`}>
        {categories?.map(category => <Button key={category.id} variant="outline" onClick={() => handleTypeSelect(category.title)} className={`text-left flex flex-col items-start gap-1 whitespace-normal min-h-[3.25rem] h-auto hover:bg-muted/50 ${isMobile ? 'p-3' : 'p-4'}`}>
            <span className={`font-medium ${isMobile ? 'text-sm' : 'text-base'}`}>
              {category.title}
            </span>
            
          </Button>)}
        
        {!showCustomInput ? <Button variant="outline" onClick={() => setShowCustomInput(true)} className={`text-left flex flex-col items-start gap-1 whitespace-normal min-h-[3.25rem] h-auto hover:bg-muted/50 ${isMobile ? 'p-3' : 'p-4'}`}>
            <span className={`font-medium ${isMobile ? 'text-sm' : 'text-base'}`}>
              Autre
            </span>
            <span className={`text-muted-foreground ${isMobile ? 'text-xs' : 'text-sm'}`}>
              décrivez votre évènement
            </span>
          </Button> : <div className="space-y-2">
            <input type="text" value={customType} onChange={e => setCustomType(e.target.value)} placeholder="Décrivez votre type d'évènement..." className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent" autoFocus />
            <div className="flex gap-2">
              <Button onClick={handleCustomTypeSubmit} disabled={!customType.trim()} size="sm">
                Valider
              </Button>
              <Button variant="outline" onClick={() => {
            setShowCustomInput(false);
            setCustomType('');
          }} size="sm">
                Annuler
              </Button>
            </div>
          </div>}
      </div>
      
      {!isMobile && <div className="text-xs text-muted-foreground bg-muted/30 p-3 rounded-lg">
          Chaque type d'évènement a ses prestations dédiées.
        </div>}
    </div>;
};